import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../helpers/Helpers";
import { BASE_URL_MEDIA } from "../../../api/Constants";
import WorkoutImageModal from "./WorkoutImageModal";
import "./WorkoutImageModal.css";
import gymgirl from "../../../images/gymgirl.jpg";
import VideoPlayerOverlay from "../../workout/common/VideoPlayerOverlay";

const WorkoutList = ({
  workouts = [], // Default to empty array to prevent undefined errors
  detail,
  order,
  isShow,
  onOrderChange,
  onShowToggle,
  onMergeModal,
  onDeleteWorkout,
  onDuplicateWorkout,
  onViewAttachment,
  currentDay,
  programId,
  formateSetsinputs,
  merge,
  removeMerge,
  mergeExerciseModal,
  removeExerciseModal
}) => {
  const [imageModal, setImageModal] = useState({
    isVisible: false,
    imageUrl: "",
    workoutName: ""
  });

  const [videoOverlayOpen, setVideoOverlayOpen] = useState(false);
  const [videoOverlayUrl, setVideoOverlayUrl] = useState("");
  const [videoOverlayTitle, setVideoOverlayTitle] = useState("Video");

  const openVideoOverlay = (url, title) => {
    setVideoOverlayUrl(url || "");
    setVideoOverlayTitle(title || "Video");
    setVideoOverlayOpen(true);
  };

  const closeVideoOverlay = () => {
    setVideoOverlayOpen(false);
    setVideoOverlayUrl("");
  };

  const handleImageClick = (workout) => {
    if (workout?.image) {
      setImageModal({
        isVisible: true,
        imageUrl: getImageUrl(workout.image, BASE_URL_MEDIA),
        workoutName: workout.name || "Workout"
      });
    }
  };

  const closeImageModal = () => {
    setImageModal({
      isVisible: false,
      imageUrl: "",
      workoutName: ""
    });
  };

  // Toggle workout selection and expansion
  const handleToggle = (index) => {
    if (order === index && isShow) {
      // If already selected and expanded, unselect and collapse
      onOrderChange(null);
      onShowToggle(false);
    } else {
      // Select and expand
      onOrderChange(index);
      onShowToggle(true);
    }
  };

  return (
    <>
      <div className="accordion" id="accordionExample">
        {workouts?.map((workout, index) => (
        <div
          key={workout.id}
          className={`accordion-item ${order === index ? "selected" : ""}`}
        >
          <label
            htmlFor={index}
            className="custom-label"
            onClick={() => handleToggle(index)}
          >
            <input
              type="radio"
              id={index}
              value={index}
              checked={order === index}
              onChange={() => {}}
            />
            <div className="accordion-headerr" id={index}>
              <div className="iconss">
                <i
                  className="fa-solid fa-object-group"
                  title="Click here to merge exercises"
                  onClick={() => onMergeModal(workout?.id)}
                ></i>
                <i
                  className="fa fa-trash"
                  onClick={() => onDeleteWorkout(workout, currentDay)}
                ></i>
                <i
                  className="fa fa-copy"
                  onClick={() => onDuplicateWorkout(programId, workout?.id)}
                ></i>
                {workout?.video && (
                  <button
                    type="button"
                    onClick={() => openVideoOverlay(workout.video, workout.name)}
                    title="Play workout video"
                    style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
                  >
                    <i className="fa fa-play-circle"></i>
                  </button>
                )}
                <Link to={`/create-workout/${detail.id}/${workout.id}`}>
                  <i className="fa fa-pencil"></i>
                </Link>
              </div>
              
              <div className="workout-header-with-image">
                {workout?.image && (
                  <img
                    src={getImageUrl(workout.image, BASE_URL_MEDIA)}
                    alt={"---"}
                    className="workout-thumbnail"
                    onClick={() => handleImageClick(workout)}
                    title="Click to view larger image"
                  />
                )}
                
                <div className="workout-header-content">
                  <p className="title" onClick={onShowToggle}>
                    {workout?.name}
                  </p>
                  <p className="value">
                    {workout?.exercises?.length} exercises (Repeats every {workout?.day})
                  </p>
                  <p className="value">{workout?.desc}</p>
                </div>
              </div>
              
              <div className="buttons">
                {workout?.workout_type && (
                  <button>{workout?.workout_type}</button>
                )}
              </div>
            </div>
          </label>
          
          <div
            id={index}
            className={`accordion-collapse collapse ${
              order === index && isShow ? "show" : ""
            }`}
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              {merge && mergeExerciseModal}
              {removeMerge && removeExerciseModal}
              
              <ul className="exercise-parent">
                {workout?.merged_exercises_collections?.map((mergedexercise) => (
                  <div key={mergedexercise.id} className="merg-container">
                    {mergedexercise?.workout_exercises?.length > 1 && (
                      <div className="video video-merge">
                        {mergedexercise?.video !== null && (
                          <button
                            type="button"
                            onClick={() => openVideoOverlay(mergedexercise?.video, "Group Video")}
                            title="Play merged group video"
                            style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
                          >
                            <i className="fa fa-video"></i>
                          </button>
                        )}
                      </div>
                    )}

                    {mergedexercise?.workout_exercises?.length > 1
                      ? mergedexercise?.workout_exercises?.map((exc, mainidex) =>
                          workout?.exercises?.map((exercise, exerciseIndex) =>
                            exercise.id == exc?.workout_exercise_id ? (
                              <li key={`${exercise.id}-${exerciseIndex}`} className="exercise-wrapper merged-exercise">
                                {mainidex == 0 && (
                                  <i
                                    className="fa-solid fa-object-ungroup"
                                    title="Click here to unmerge exercises"
                                    onClick={() => workout.onOpenRemoveModal && workout.onOpenRemoveModal(workout?.id, mergedexercise?.id)}
                                  ></i>
                                )}
                                {renderExerciseContent(exercise, workout, formateSetsinputs, openVideoOverlay)}
                              </li>
                            ) : null
                          )
                        )
                      : mergedexercise?.workout_exercises?.map((exc) =>
                          workout?.exercises?.map((exercise, exerciseIndex) =>
                            exercise.id == exc?.workout_exercise_id ? (
                              <li key={`${exercise.id}-${exerciseIndex}`} className="exercise-wrapper">
                                {renderExerciseContent(exercise, workout, formateSetsinputs, openVideoOverlay)}
                              </li>
                            ) : null
                          )
                        )}
                  </div>
                ))}
              </ul>
            </div>
          </div>

          {workout?.attachments.length > 0 && (
            <div className="d-flex flex-row justify-content-start aling-items-center my-3 px-3">
              <div
                className="workout-attachmet-button d-flex flex-row justify-content-start align-items-center gap-2 pointer"
                title="View Attachments"
                onClick={() => onViewAttachment(workout)}
              >
                {workout?.attachments.length} Attachments{" "}
                <i style={{ color: "green" }} className="fa fa-eye"></i>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
    
    <WorkoutImageModal
      isVisible={imageModal.isVisible}
      imageUrl={imageModal.imageUrl}
      workoutName={imageModal.workoutName}
      onClose={closeImageModal}
    />
    <VideoPlayerOverlay
      isOpen={videoOverlayOpen}
      url={videoOverlayUrl}
      title={videoOverlayTitle}
      onClose={closeVideoOverlay}
    />
  </>
  );
};

const renderExerciseContent = (exercise, workout, formateSetsinputs, openVideoOverlay) => {
  return (
    <>
      <div className="icon-wrapper">
        <div className="icon">
          {exercise?.name?.substring(0, 2)}
        </div>
        <div className="data">
          <p className="title">{exercise?.name}</p>
          <p className="subtitle">
            Sets:
            {workout?.workout_type === "AMRAP" ? (
              <span>Max</span>
            ) : (
              <span>{exercise?.sets?.length}</span>
            )}
            {Object.entries(formateSetsinputs(exercise?.sets)).map(
              ([fieldName, values]) => (
                <span key={fieldName} className="valss bluee">
                  {`${fieldName}: ${values.join("/")} `}
                  <span className="bluee">
                    {getFieldUnit(fieldName)}
                  </span>
                </span>
              )
            )}
          </p>
        </div>
      </div>
      <div className="video">
        {exercise?.video !== null && (
          <button
            type="button"
            onClick={() => openVideoOverlay && openVideoOverlay(exercise?.video, exercise?.name)}
            title="Play video"
            style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
          >
            <i className="fa fa-video"></i>
          </button>
        )}
      </div>
    </>
  );
};

const getFieldUnit = (fieldName) => {
  const units = {
    "WEIGHT": "kgs",
    "Distance": "meters",
    "CALORIES": "calories",
    "DURATION": "minutes",
    "REPETITIONS": "reps",
    "DISTANCE": "meters",
    "Jump Row": "meters"
  };
  return units[fieldName] || "";
};

export default WorkoutList;
